import SignedInAvatar from 'components/SignedInAvatar/SignedInAvatar';
import { IClinicData } from 'redux/clinicDetailsSlice';
import { useAppSelector } from 'redux/reduxHooks';
import NoAvatarScr from 'assets/images/no-avatar.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as PrevIcon } from 'assets/icons/left-darker.svg';

import styles from './HeaderSectionIframe.module.scss';
import { POST_MESSAGE_ACTION } from 'utils/constants/common';

const { BACK_TO_PRACTICE, CLOSE_WIDGET } = POST_MESSAGE_ACTION;

const HeaderSectionIframe = ({ clinicData }: { clinicData: IClinicData }) => {
  const { isLoggedIn } = useAppSelector((state) => state.authSlice);

  const isMultiPractice =
    new URLSearchParams(window.location.search).get('multiPractice') === 'true';

  const onClose = () => {
    window.parent.postMessage(CLOSE_WIDGET, '*');
  };

  const onBack = () => {
    window.parent.postMessage(BACK_TO_PRACTICE, '*');
  };

  return (
    <div className={styles['container']}>
      {isMultiPractice && (
        <PrevIcon className={styles['back-icon']} onClick={onBack} />
      )}
      {isLoggedIn && <SignedInAvatar />}
      <img
        src={clinicData.avatar ? clinicData.avatar : NoAvatarScr}
        alt="booking-avatar"
        className={`${styles['avatar']} `}
      />

      <div className={styles['clinic-info']}>
        <b className={styles['clinic-name']}>{clinicData.name}</b>
        <div className={styles['clinic-address']}>{clinicData.address}</div>
      </div>

      <CloseIcon className={styles['close-icon']} onClick={onClose} />
    </div>
  );
};

export default HeaderSectionIframe;
